/**
 * 三包登记的新增页面 货品配置处理
 * @author zjs
 * @time 2017-09-18
 */
import utils from '@/utils'
let vm = {
    isTriggerFunc: true, // 标识是否触发func配置的调用
    data () {
        return {
            tbConfig: {
                "height":0,
                "isNumber":true,
                "isCheckbox":false,
                "btnsWidth":40,
                "width":"auto"
            },
            productConfig: [
            {
                "prop":"product_cai",
                "label":"货品编码",
                "width": 150,
                component: 'ElInput'
            },{
                prop: 'full_name',
                label: '货品名称',
                width: "auto",
                component: 'ElInput'
            }, {
                prop: 'specification',
                label: '货品规格',
                width: 150,
                component: 'ElInput'
            }, {
                prop: 'quantity',
                label: '数量',
                width: 100,
                json: {
                    min: 1
                },
                component: 'LyInputNumber'
            }, {
                prop: 'price',
                label: '单价',
                width: 100,
                json: {
                    min: -Infinity
                },
                component: 'LyInputNumber'
            }, {
                prop: 'xiaoji',
                label: '金额',
                width: 120,
                json: {
                    min: -Infinity
                },
                component: 'LyInputNumber'
            },
            {
                "prop":"transaction_no_display",
                "label":"引用单据号",
                "width": 190,
                component: 'ElInput'
            }, 
            {
                type: 'function',
                /**
                 * 此函数的作用，是计算每行的金额。但每行的金额是可以改变的，改变了不影响数量和单价
                 * 这种需求，目前用一个零时变量来对比数量和单价的变化，再去改变金额
                 * 更好的解决方式，应该是每个组件配置一个函数，让它改变时去处理对应的逻辑
                 */
                func (list, callback) {
                    // 如果是修改，初始的数据不用进行计算小记金额
                    if (!vm.isTriggerFunc) {
                        vm.isTriggerFunc = true
                        // callback 必须要有 by welpher 2022-1-17
                        callback()
                        return
                    }
                    vm.timer && clearTimeout(vm.timer)
                    // 延迟执行
                    vm.timer = setTimeout(() => {
                        // 遍历货品数据
                        list.forEach((v, k) => {
                            let ref = true // 标识是否计算金额的值
                            if (vm.productList && vm.productList[k]) {
                                let product = vm.productList[k]
                                // 单价和数量弯曲一样的话，不进行金额的计算
                                if (product.quantity === v.quantity && product.price === v.price) {
                                    ref = false
                                }
                            }
                            // 计算每行的金额
                            if (ref) {
                                v.xiaoji = parseFloat(parseFloat(v.quantity) * parseFloat(v.price)).toFixed(2)
                            }
                        })
                        // 暂存当前列表
                        vm.productList = utils.deepClone(list)
                        // callback 必须要有 by welpher 2022-1-17
                        callback()
                    }, 500)
                }
            }]
        }
    }
}

export default vm